import DataTablesBase from '../datatables.js';
import jobsDialog from '../elements/jobsDialog.js';

const Jobs = new DataTablesBase();

jobsDialog.init();

export default Jobs;
